import { OnlineStorage } from "@tblabs/storage";
import { Button, TextInput, RefString } from "@tblabs/truffle";
import { v4 as uuidv4 } from 'uuid';
import { UserProvider } from "../Services/UserProvider";
import { Chat } from "../Services/Chat";
import { Page } from "./Page";
import { InfoBox } from "../Components/InfoBox";
import { Center } from "../Components/Utils/Center";


export class NewChatPage extends Page
{
    constructor(_storage: OnlineStorage, _user: UserProvider)
    {
        super("Nowy czat");

        this.Content(async (body) =>
        {
            const userName = new RefString();
            body.Append(
                "\n\nWpisz swoją nazwę użytkownika albo zostanie przydzielona losowa nazwa\n\n",

                new TextInput(userName).WidthAuto().Placeholder("Nazwa użytkownika"),
                "\n",
                new Button("Utwórz nowy czat").Class("uk-button uk-button-primary").MarginTop(8)
                    .OnClick(async () =>
                    {
                        try
                        {
                            _user.Id = userName.value.trim().replaceAll(";", "_");

                            const randomId = uuidv4();
                            const newChatId = randomId.substring(0, 8).toUpperCase();
                            const chat = new Chat(_storage, _user, newChatId);
                            await chat.Create();

                            window.location.hash = `chat/${newChatId}`;
                        }
                        catch (ex: any)
                        {
                            this.Clear().Append(
                                new InfoBox("Nie udało się utworzyć czatu", ex.message),
                                new Center(
                                    new Button("Spróbuj ponownie").Class("uk-button uk-button-primary").MarginTop(8)
                                        .OnClick(async () => window.location.reload())
                                ),
                            )
                        }
                    }),

                "\n\nDo czata ma dostęp każdy kto ma link i nikt poza tym.\nCzat nie odświeża się automatycznie!"
            );
        });
    }
}
